import { AppLanguage } from 'app/config/i18Config/types';
import { StateSchema } from 'app/config/storeConfig/types';

export const getSelectedLanguage = (state: StateSchema): Nullable<AppLanguage> => state.sendFranchiseSectionModal.selectedLanguage;
